

const ms183 = {
  label: "Locker Surrender",
  pageLabel: "Locker Surrender",
  starting: true,
  url: "ms183",
  pageType: "history",
  form: [
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Branch",
      label: "Parent Branch",
      name: "",
      description: "Enter Branch"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      tab: "create",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "branch-1",
          value: "branch-1"
        },
        {
          label: "branch-2",
          value: "branch-2"
        },
        {
          label: "branch-3",
          value: "branch-3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "createParentBranch",
      description: "Enter branch code"
    },
    {
      inputType: "showdata",
      tab: "create",
      data: "createParentBranch",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Locker Type",
      label: "Locker Type",
      name: "",
      description: "Select Locker Type"
    },
    {
      inputType: "select",
      isRequired: true,
      tab: "create",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "Locker Type-1",
          value: "Locker Type-1"
        },
        {
          label: "Locker Type-2",
          value: "Locker Type-2"
        },
        {
          label: "Locker Type-3",
          value: "Locker Type-3"
        }
      ],
      placeHolder: "Locker Type",
      //   label: "Branch Code",
      name: "createLockerType",
      description: "Select Locker Type"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-7",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Locker Number",
      label: "Locker Number",
      name: "",
      description: "Enter Locker Number"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      tab: "create",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "Locker Number-1",
          value: "Locker Number-1"
        },
        {
          label: "Locker Number-2",
          value: "Locker Number-2"
        },
        {
          label: "Locker Number-3",
          value: "Locker Number-3"
        }
      ],
      placeHolder: "Locker Number",
      //   label: "Branch Code",
      name: "createLockerNumber",
      description: "Select Locker Number"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-7",
        children: "col-sm-12"
      },
      placeHolder: "Product",
      label: "Product",
      name: "",
      description: "Enter Product"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Product",
      label: "Product",
      name: "",
      description: "Enter Product"
    },
    {
      inputType: "autocomplete",
      isRequired: true,

      tab: "create",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "product-1",
          value: "product-1"
        },
        {
          label: "product-2",
          value: "product-2"
        },
        {
          label: "product-3",
          value: "product-3"
        }
      ],
      placeHolder: "product",
      //   label: "Branch Code",
      name: "createProduct",
      description: "Enter product"
    },
    {
      inputType: "showdata",
      tab: "create",
      data: "createProduct",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Account No.",
      label: "Account No.",
      name: "",
      description: "Enter Account No."
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      tab: "create",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "Account Number-1",
          value: "Account Number-1"
        },
        {
          label: "Account Number-2",
          value: "Account Number-2"
        },
        {
          label: "Account Number-3",
          value: "Account Number-3"
        }
      ],
      placeHolder: "AccountNumber",
      //   label: "Branch Code",
      name: "createAccountNumber",
      description: "Enter AccountNumber"
    },
    {
      inputType: "showdata",
      tab: "create",
      data: "createAccountNumber",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Customer No.",
      label: "Customer No.",
      name: "",
      description: "Enter Customer No."
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      tab: "create",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "Customer Number-1",
          value: "Customer Number-1"
        },
        {
          label: "Customer Number-2",
          value: "Customer Number-2"
        },
        {
          label: "Customer Number-3",
          value: "Customer Number-3"
        }
      ],
      placeHolder: "CustomerNumber",
      //   label: "Branch Code",
      name: "createCustomerNumber",
      description: "Enter CustomerNumber"
    },
    {
      inputType: "showdata",
      tab: "create",
      data: "createCustomerNumber",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Effective Date",
      label: "Effective Date",
      name: "",
      description: "Effective Date"
    },
    {
      inputType: "date",
      isRequired: true,
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Effective Date",
      name: "Effective date",
      description: "Enter from Effective date"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-8",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Rent",
      label: "Rent",
      name: "",
      description: "Enter Rent"
    },
    {
      inputType: "numberonly",
      isRequired: true,
      tab: "create",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Rent",
      label: "",
      name: "Rent",
      description: "Enter Rent"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-7",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Deposit",
      label: "Deposit",
      name: "",
      description: "Enter Deposit"
    },
    {
      inputType: "numberonly",
      tab: "create",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Deposit",
      label: "",
      name: "Deposit",
      description: "Enter Deposit"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-7",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Surrender Date",
      label: "Surrender Date",
      name: "",
      description: "Surrender Date"
    },
    {
      inputType: "date",
      isRequired: true,
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Surrender Date",
      name: "Surrender date",
      description: "Enter from Surrender date"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-8",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Rent From Account No.",
      label: "Rent From Account No.",
      name: "",
      description: "Enter Rent From Account No."
    },
    {
      inputType: "numberonly",
      tab: "create",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Rent From Account No.",
      label: "",
      name: "RentFromAccountNo",
      description: "Enter Rent From Account No."
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-7",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Rent Date",
      label: "Rent Date",
      name: "",
      description: "Rent Date"
    },
    {
      inputType: "date",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Rent Date",
      name: "Rent date",
      description: "Enter from Rent date"
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-8",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "create",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Standing instr. Number",
      label: "Standing instr. Number",
      name: "",
      description: "Enter Standing instr. Number"
    },
    {
      inputType: "numberonly",
      tab: "create",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Standing instr. Number",
      label: "",
      name: "standingInstructionNumber",
      description: "Enter Standing instr. Number"
    }
  ]
};

export default ms183;
